/**
 * Confirmation card for write actions the orchestrator proposes.
 *
 * Writes never happen silently: the model emits a draft (`confirmation` event),
 * this card shows it, and only an explicit "Bevestigen" triggers the
 * server-side execute. "Annuleren" writes nothing and the conversation
 * continues (draft → approve → execute, same split as the MCP spec).
 *
 * @param {object} props
 * @param {string} props.title - What will happen (e.g. "Effect bijwerken").
 * @param {string} props.body - Human-readable summary of the proposed change.
 * @param {() => void} props.onApprove - Called when the user confirms.
 * @param {() => void} props.onCancel - Called when the user cancels.
 * @param {boolean} [props.busy] - True while the server executes the action.
 */
const ConfirmationCard = ({ title, body, onApprove, onCancel, busy = false }) => (
  <div className="decca-confirmation-card" role="group" aria-label="Bevestiging">
    <p className="decca-confirmation-title">{title}</p>
    <div className="decca-confirmation-body">{body}</div>
    <div className="decca-confirmation-actions">
      <button
        type="button"
        className="decca-confirm-btn decca-confirm-btn--approve"
        onClick={onApprove}
        disabled={busy}
      >
        {busy ? "Bezig…" : "Bevestigen"}
      </button>
      <button
        type="button"
        className="decca-confirm-btn decca-confirm-btn--cancel"
        onClick={onCancel}
        disabled={busy}
      >
        Annuleren
      </button>
    </div>
  </div>
);

export default ConfirmationCard;
